

















































































import { Component, Vue, Model, Prop } from "vue-property-decorator";

@Component
export default class DataTable extends Vue {
  @Model("change", { type: Boolean }) descending!: boolean;

  @Prop(Array) headers!: Array<any>;
  @Prop(Array) items!: Array<any>;
  @Prop(Boolean) loading!: boolean;

  pagination: any = {
    sortBy: this.descending ? "customerSurveyId" : "status",
    descending: this.descending,
    totalItems: this.totalItems,
    rowsPerPage: 100
  };
  search: string = "";

  get pages() {
    return this.pagination.rowsPerPage == 0 || this.totalItems == 0
      ? 0
      : Math.ceil(this.totalItems / this.pagination.rowsPerPage);
  }

  get page() {
    return this.pagination.page;
  }

  get totalItems() {
    return this.items.length;
  }

  get pageStart() {
    // @ts-ignore
    return this.$refs.datatable.pageStart + 1;
  }

  get pageStop() {
    // @ts-ignore
    return this.$refs.datatable.pageStop;
  }
}
